import { render, staticRenderFns } from "./ServicesSetup.vue?vue&type=template&id=19aee6df&scoped=true&"
import script from "./ServicesSetup.vue?vue&type=script&lang=js&"
export * from "./ServicesSetup.vue?vue&type=script&lang=js&"
import style0 from "./ServicesSetup.vue?vue&type=style&index=0&id=19aee6df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aee6df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19aee6df')) {
      api.createRecord('19aee6df', component.options)
    } else {
      api.reload('19aee6df', component.options)
    }
    module.hot.accept("./ServicesSetup.vue?vue&type=template&id=19aee6df&scoped=true&", function () {
      api.rerender('19aee6df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/ServicesSetup.vue"
export default component.exports